export enum EPresentationCategories {
  PRESENTATION = 'Prezentacja',
  STRATEGY = 'Strategia',
  MAIN_PRESENTATION = 'Główna Prezentacja',
  INCENTIVE_PROGRAM = 'Program Motywacyjny',
  OTHER = 'Inne',
}
